import { render, staticRenderFns } from "./hero-item.vue?vue&type=template&id=c2be5414&scoped=true&"
import script from "./hero-item.vue?vue&type=script&lang=js&"
export * from "./hero-item.vue?vue&type=script&lang=js&"
import style0 from "./hero-item.vue?vue&type=style&index=0&id=c2be5414&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2be5414",
  null
  
)

export default component.exports